import { Button } from "@progress/kendo-react-buttons";
import { Menu, MenuItem, MenuSelectEvent } from "@progress/kendo-react-layout";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../redux/slices/appStateSlice";
import { headerRoutes } from "../routes/HeaderRoutes";
import './menuheader.css';

export default function MenuHeader() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onSelect = async (event: MenuSelectEvent) => {
        if (event.item.data?.type === "logout") {
            navigate('/');
            dispatch(logout());
        }
    };

    const customLinkRender = () => {
        return (<div className="k-cursor-pointer k-d-flex k-align-items-center k-h-full app-infos">
            <h1 className="app-title">APPROBATION WEB</h1>
            {process.env.REACT_APP_ENV === "DEV" && (<Button className="environment-button" disabled>
                {process.env.REACT_APP_ENV}
            </Button>)}
        </div>);
    };

    return (<Menu onSelect={onSelect} openOnClick={true} className="k-d-flex k-justify-content-between k-cursor-pointer k-flex-grow-0 k-min-w-full" style={{
        boxShadow: "0 0 10px rgb(0 0 0)", zIndex: '10', height: '50px', backgroundColor: process.env.REACT_APP_COLOR
    }}>
        <MenuItem url={"/"} linkRender={customLinkRender} />
        <MenuItem text="Mon compte" cssClass={`header-menu-item k-text-center`} cssStyle={{ zIndex: 2147483647 }}>
            {headerRoutes.map((e, i) => (<MenuItem text={e.text} icon={e.icon} url={e.route} data={e.data} cssClass="child-menu-item account-menu" key={i} />))}
        </MenuItem>
    </Menu>)
}